import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK, HAS_WHATSAPP } from "../contexts/LanguageContext";

export default function WhatsAppButton() {
  if (!HAS_WHATSAPP) return null;
  return (
    <a
      data-testid="floating-whatsapp"
      href={WHATSAPP_LINK("Hi Capital Bay, I came from your website.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 start-6 z-40 w-14 h-14 rounded-full bg-cb-emerald text-white grid place-items-center shadow-xl wa-pulse hover:scale-110 transition-transform"
    >
      <MessageCircle size={24} />
    </a>
  );
}
